import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

function Footer() {
  const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const iconVariants = {
    hover: { scale: 1.2, transition: { duration: 0.2 } },
  };

  return (
    <footer className="bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          className="grid md:grid-cols-3 gap-8"
          initial="hidden"
          whileInView="visible"
          variants={footerVariants}
          viewport={{ once: true }}
        >
          {/* Sección 1: Información de la empresa */}
          <div>
            <h3 className="text-lg font-semibold mb-4">lawfeed</h3>
            <p className="text-gray-600">
              Conectando clientes con bufetes de abogados de confianza.
            </p>
            <div className="flex space-x-4 mt-4">
              <motion.a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                variants={iconVariants}
                whileHover="hover"
              >
                <FaFacebook className="text-blue-600 text-xl hover:text-blue-700" />
              </motion.a>
              <motion.a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                variants={iconVariants}
                whileHover="hover"
              >
                <FaTwitter className="text-blue-400 text-xl hover:text-blue-500" />
              </motion.a>
              <motion.a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                variants={iconVariants}
                whileHover="hover"
              >
                <FaLinkedin className="text-blue-800 text-xl hover:text-blue-900" />
              </motion.a>
              <motion.a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                variants={iconVariants}
                whileHover="hover"
              >
                <FaInstagram className="text-pink-600 text-xl hover:text-pink-700" />
              </motion.a>
            </div>
          </div>

          {/* Sección 2: Enlaces rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/bufetes"
                  className="text-blue-600 hover:underline hover:text-blue-700 transition duration-300"
                >
                  Buscar Bufetes
                </Link>
              </li>
              <li>
                <Link
                  to="/registro-cliente"
                  className="text-blue-600 hover:underline hover:text-blue-700 transition duration-300"
                >
                  Registro de Clientes
                </Link>
              </li>
              <li>
                <Link
                  to="/registro-bufete"
                  className="text-blue-600 hover:underline hover:text-blue-700 transition duration-300"
                >
                  Registro de Bufetes
                </Link>
              </li>
            </ul>
          </div>

          {/* Sección 3: Contacto */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <p className="text-gray-600">Email: info@lawfeed.com</p>
            <p className="text-gray-600">Teléfono: +1 234 567 890</p>
          </div>
        </motion.div>

        {/* Sección de derechos reservados */}
        <motion.div
          className="mt-8 pt-8 border-t border-gray-200 text-center text-gray-500"
          initial="hidden"
          whileInView="visible"
          variants={footerVariants}
          viewport={{ once: true }}
        >
          © 2023 LawFeed. Todos los derechos reservados.
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;